import 'svelte/internal/disclose-version';

Reset[$.FILENAME] = 'src/pages/Reset.svelte';

import * as $ from 'svelte/internal/client';
import Field from "../components/Field.svelte";
import api from "../lib/api.js";
import { route, navigate } from "../lib/router.svelte.js";
import { setUser } from "../lib/session.svelte.js";
import { toastSuccess } from "../lib/toast.svelte.js";

var root = $.add_locations($.from_html(`<p class="sub svelte-1rpu2b">This link is missing its reset code. Request a new one from the <a href="/forgot-password" class="svelte-1rpu2b">forgot password</a> page.</p>`), Reset[$.FILENAME], [[40, 6, [[40, 85]]]]);
var root_1 = $.add_locations($.from_html(`<p class="error svelte-1rpu2b"> </p>`), Reset[$.FILENAME], [[46, 19]]);
var root_2 = $.add_locations($.from_html(`<p class="sub svelte-1rpu2b">Pick something you'll remember — at least 8 characters with a number or symbol.</p> <form class="svelte-1rpu2b"><!> <!> <!> <button class="primary svelte-1rpu2b" type="submit"> </button></form>`, 1), Reset[$.FILENAME], [[42, 6], [43, 6, [[47, 8]]]]);
var root_3 = $.add_locations($.from_html(`<div class="auth svelte-1rpu2b"><div class="card svelte-1rpu2b"><h1 class="svelte-1rpu2b">Choose a new password</h1> <!></div></div>`), Reset[$.FILENAME], [[36, 0, [[37, 2, [[38, 4]]]]]]);

const $$css = {
	hash: 'svelte-1rpu2b',
	code: '\n  .auth.svelte-1rpu2b { display: grid; place-items: center; padding: 56px 0 72px; }\n  .card.svelte-1rpu2b {\n    width: min(420px, 100%);\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius-lg);\n    padding: 32px;\n    box-shadow: var(--shadow);\n  }\n  h1.svelte-1rpu2b { font-size: 1.6rem; }\n  .sub.svelte-1rpu2b { margin: 8px 0 22px; color: var(--ink-soft); line-height: 1.55; font-size: 0.94rem; }\n  .sub.svelte-1rpu2b a:where(.svelte-1rpu2b) { color: var(--accent); font-weight: 600; }\n  form.svelte-1rpu2b { display: flex; flex-direction: column; gap: 14px; }\n  .error.svelte-1rpu2b { margin: 0; color: var(--accent-dark); font-size: 0.87rem; }\n  .primary.svelte-1rpu2b {\n    background: var(--accent);\n    color: #fff;\n    border: none;\n    font-weight: 600;\n    padding: 13px;\n    border-radius: var(--radius-pill);\n    cursor: pointer;\n    margin-top: 4px;\n  }\n  .primary.svelte-1rpu2b:hover:not(:disabled) { background: var(--accent-dark); }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function Reset($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Reset);
	$.append_styles($$anchor, $$css);

	let password = $.tag($.state(""), 'password');
	let confirm = $.tag($.state(""), 'confirm');
	let busy = $.tag($.state(false), 'busy');
	let error = $.tag($.state(""), 'error');
	const token = $.tag($.derived(() => route.query.get("token") ?? ""), 'token');

	async function submit(event) {
		event.preventDefault();
		$.set(error, "");

		if ($.strict_equals($.get(password), $.get(confirm), false)) {
			$.set(error, "Those two passwords don't match.");

			return;
		}

		$.set(busy, true);

		try {
			const response = (await $.track_reactivity_loss(api.resetPassword($.get(token), $.get(password))))();

			(await $.track_reactivity_loss(setUser(response.user)))();
			toastSuccess("Password updated.");
			navigate("/");
		} catch(e) {
			$.set(error, e.message ?? "Couldn't reset that password.", true);
		} finally {
			$.set(busy, false);
		}
	}

	var $$exports = { ...$.legacy_api() };
	var div = root_3();
	var div_1 = $.child(div);
	var node = $.sibling($.child(div_1), 2);

	{
		var consequent = ($$anchor) => {
			var p = root();

			$.append($$anchor, p);
		};

		var alternate = ($$anchor) => {
			var fragment = root_2();
			var form = $.sibling($.first_child(fragment), 2);
			var node_1 = $.child(form);

			$.add_svelte_meta(
				() => Field(node_1, {
					label: 'New password',
					name: 'password',
					type: 'password',
					required: true,
					autocomplete: 'new-password',
					get value() {
						return $.get(password);
					},

					set value($$value) {
						$.set(password, $$value, true);
					}
				}),
				'component',
				Reset,
				44,
				8,
				{ componentTag: 'Field' }
			);

			var node_2 = $.sibling(node_1, 2);

			$.add_svelte_meta(
				() => Field(node_2, {
					label: 'Confirm password',
					name: 'confirm',
					type: 'password',
					required: true,
					autocomplete: 'new-password',
					get value() {
						return $.get(confirm);
					},

					set value($$value) {
						$.set(confirm, $$value, true);
					}
				}),
				'component',
				Reset,
				45,
				8,
				{ componentTag: 'Field' }
			);

			var node_3 = $.sibling(node_2, 2);

			{
				var consequent_1 = ($$anchor) => {
					var p_1 = root_1();
					var text = $.child(p_1, true);

					$.reset(p_1);
					$.template_effect(() => $.set_text(text, $.get(error)));
					$.append($$anchor, p_1);
				};

				$.add_svelte_meta(
					() => $.if(node_3, ($$render) => {
						if ($.get(error)) $$render(consequent_1);
					}),
					'if',
					Reset,
					46,
					8
				);
			}

			var button = $.sibling(node_3, 2);
			var text_1 = $.child(button, true);

			$.reset(button);
			$.reset(form);

			$.template_effect(() => {
				button.disabled = $.get(busy);
				$.set_text(text_1, $.get(busy) ? "Saving…" : "Save password");
			});

			$.event('submit', form, submit);
			$.append($$anchor, fragment);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$.get(token)) $$render(consequent); else $$render(alternate, -1);
			}),
			'if',
			Reset,
			39,
			4
		);
	}

	$.reset(div_1);
	$.reset(div);
	$.append($$anchor, div);

	return $.pop($$exports);
}